export const combineStringList = (stringList: string[]) => {
  if (stringList.length === 0) {
    return '';
  }

  if (stringList.length === 1) {
    return stringList[0];
  }

  const last = stringList.pop();
  return `${stringList.join(', ')} and ${last}`;
};
